/* product.js — product page interactions. Two independent,
   progressive enhancements; the page is fully usable without either.

   1. Gallery thumb switching: [data-gallery-thumbs] buttons swap the main
      .pdp-main-img with a short crossfade. The swap intentionally clears
      srcset/sizes — thumbs carry one 1200w URL (data-full) and keeping the
      original element's srcset would let the browser ignore the new src.
   2. Sticky CTA bar: [data-pdp-sticky] appears once the hero .cta-row
      leaves the viewport (IntersectionObserver; no scroll listeners).

   Loaded only on the product template (see theme.liquid's gated script
   block, same pattern as facets.js). */

const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function initGallery() {
  const rail = document.querySelector('[data-gallery-thumbs]');
  const main = document.querySelector('.pdp-main-img');
  if (!rail || !main) return;
  rail.addEventListener('click', (e) => {
    const btn = e.target.closest('button[data-full]');
    if (!btn || btn.classList.contains('on')) return;
    rail.querySelectorAll('button.on').forEach((b) => b.classList.remove('on'));
    btn.classList.add('on');
    const swap = () => {
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = btn.dataset.full;
    };
    if (REDUCED) { swap(); return; }
    main.classList.add('is-fading');
    const done = () => {
      swap();
      const reveal = () => {
        main.classList.remove('is-fading');
        main.removeEventListener('load', reveal);
      };
      if (main.complete) main.classList.remove('is-fading');
      else main.addEventListener('load', reveal);
    };
    setTimeout(done, 140);
  });
}

function initSticky() {
  const bar = document.querySelector('[data-pdp-sticky]');
  const sentinel = document.querySelector('.pdp .cta-row');
  if (!bar || !sentinel || !('IntersectionObserver' in window)) return;
  bar.hidden = false;
  const io = new IntersectionObserver(([entry]) => {
    bar.classList.toggle('show', !entry.isIntersecting && entry.boundingClientRect.top < 0);
  }, { threshold: 0 });
  io.observe(sentinel);
}

initGallery();
initSticky();
